import React from 'react';
import type { QuickReply } from './chatTypes';

type QuickReplyBarProps = {
  items: QuickReply[];
  onPick: (text: string) => void;
  disabled?: boolean;
};

export function QuickReplyBar({ items, onPick, disabled }: QuickReplyBarProps) {
  if (items.length === 0) {
    return null;
  }
  return (
    <div className="chat-scroll flex gap-2 overflow-x-auto border-t border-[#eef0f4] px-5 py-2.5">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          disabled={disabled}
          className="shrink-0 cursor-pointer whitespace-nowrap rounded-full border border-[#e5e7eb] bg-white px-3 py-1 text-xs text-slate-600 transition-colors hover:border-[#596ae8]/40 hover:text-[#596ae8] disabled:cursor-not-allowed disabled:opacity-50"
          onClick={() => onPick(item.text ?? item.label)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
